<template>
	<div class="wnds_home">
		<div class="wh_banner">
			<div class="swiper">
				<el-carousel  :interval="3000"  :height="bannerHeight+'px'" trigger="click">
					<el-carousel-item v-for="item in swiperList" :key="item.id" >
					<el-row>
							<el-col :span='24' class="banner_img">
									<img  ref="bannerHeight" :src="item.str_img_url_cn"   @load='imgload' @click="goLink(item)"  @mouseover="urlStyle(item)" :class="isfalse==false ? 'isUrl': ''">
							</el-col>
					</el-row>
					</el-carousel-item>
      	</el-carousel>
			</div>
		</div>
		<div class="wh_aboutusbox">
			<div class="wh_aboutusbox">
				<div class="wha_lficon"></div>
				<img src="../../../static/img/wha_lficon_bgm.png" alt="" class="wha_lficon_bgm" style="">
				<div class="wh_aboutus">
					<img src="../../../static/img/wnds_content_title_01.png" alt="" srcset="" class="wha_title01">
					<div class="wha_content01 tcf-flex tcf-justify-justify">
						<div class="whac_logo" id="videoImg">
							<img src="../../../static/img/home_aboutus.3e75ade.png" alt="" srcset="" >
							<img src="../../../static/img/what_btn.png" alt="" class="what_btn"  @click="playingVideo()"/>
						</div>
						<video width="536" height="340" controls id="video">
							<source src="https://www.thepoemforyou.com/mp4/homevodia.mp4" type="video/mp4" >
						</video>
						<div class="whac_text">
							<p>关于「为你读诗」</p>
							<p></p>
							<p>「为你读诗」是一个以诗歌为起点和纽带的国际文化艺术交流平台和诗意生活品牌。
									它致力于推动文化——尤其是中国文化，进入大众日常生活场景。<br>
									我们期待通过具有创造力的方式，将文学、音乐、美术、哲学、美学、戏剧、心理学等文化内容，开发为多样态的内容、产品与服务。<br>
									我们希望为更为广泛的用户带去兼有“知识、审美和情感”的诗意生活。<br>
									在这个飞速行进的时代，我们需要安静、思考和美。
							</p>
							<img src="../../../static/img/whac_getmore_btn.png" alt="" srcset="" class="whac_getmore" @click="goAbout()">
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="wh_ltgzbox">
			<div class="wh_ltgz">
				<img class="whl_title02" src="../../../static/img/wnds_content_title_02.png" alt="">
				<el-carousel  :interval="4000"  height="480px"  id="audSwiper" :autoplay="swiperBtn">
					<el-carousel-item v-for="(item, index) in ltgzlist" :key="index" >
						<div class="whlc_text">
							<p>{{item.str_peam_title}}</p>
							<p>作者：{{item.str_autor_info}}<br/>为你读诗：{{item.str_readpeam_user}} <br> 译者：{{item.str_translate_name}} </p>
							<div class="whlc_txtdet_box">
								<div class="whlc_txtdet" v-html="item.str_peam_content"></div>
							</div>
						</div>
						<div class="whlc_logo">
							<img class="whlc_logo_bgm" :src="item.str_img_url" alt="" srcset="">
							<img class="whlc_btn" :src="audioPlay" alt="" srcset="" @click="playingAudio('audio'+index)" :id="'audioPlayeraudio'+index">
							<audio :src="item.str_audio_url" :id="'audio'+index" ></audio>
							<img class="whlc_logo_shawn" :src="item.str_img_url" alt="" srcset="">
							<div class="whlc_logo_shawn_top"></div>
						</div>
						<img class="whlc_bg_icon" src="../../../static/img/whlc_bg_icon.png" alt="" srcset="">
					</el-carousel-item>
				</el-carousel>
					<img src="../../../static/img/whac_getmore_btn.png" alt="" srcset="" class="whac_getmore_ltgz" @click="goDiscover()">
			</div>
		</div>

		<div class="wh_newsbox">
			<div class="wh_news">
				<!-- <img class="whn_title03" src="../../../static/img/wnds_content_title_03.png" alt=""> -->
				<div class="newsTitle">
					<h2>活动资讯</h2>
					<h1>NEWS</h1>
				</div>
				<div class="whn_contentbox">
					<div class="whnc_list tcf-flex tcf-justify-justify">
						<div class="whnc_slider" v-for="(item, index) in whncSliderList" :key="index" :newin="index" @click="goDetails(item.id)">
							<img :src="item.pc_img_url" alt="">
							<p class="strNewsTitle p_after" style="height: 57px;">{{item.str_news_title}}</p>
							<p class="strKey p_after_strKey" style="height: 59px;">{{item.str_keys}}</p>
							<img src="../../../static/img/whac_readdetail.png" alt=""  :newsid="item.id"  style="margin-left:20px;">
						</div>
						<div data-v-318131b2="" class="whnc_slider whnc_slider_empt"></div>
						<div data-v-318131b2="" class="whnc_slider whnc_slider_empt"></div>
						<div data-v-318131b2="" class="whnc_slider whnc_slider_empt"></div>
					</div>
				</div>
			</div>
		</div>
		<div style="width:100%;height:506px">
			<img src="../../../static/img/2banner_02.png" alt="" style="width:100%;height:100%;">
		</div>

		<div class="wh_partnerbox">
			<div class="wh_partner">
				<img class="whp_title04" src="../../../static/img/wnds_content_title_04.png" alt="">

				<div class="mediaPartners_box">
					<h2>—— 媒体伙伴 ——</h2>
					<div class="logo_box">
						<div class="logo1" v-for="(item,index) in mediaPartnersList" :key="index" @mouseenter="enter1(index)" @mouseleave="leave1(index)">
							<img :src="item" alt="" class="logo1img">
						</div>
					</div>
				</div>

				<div  class="businessPartnersList">
					<h2>—— 企业品牌 ——</h2>
					<div class="logo_box">
						<div class="logo2" v-for="(item,index) in businessPartnersList" :key="index" @mouseenter="enter2(index)" @mouseleave="leave2(index)">
							<img :src="item" alt="" class="logo2img">
						</div>
					</div>
				</div>

			</div>
		</div>

	</div>
</template>
<script>
	// import Swiper from 'swiper';
	import audioPlay from '../../../static/img/what_btn.png'
  import audioPause from  '../../../static/img/play_icon_03.png'
	import AboutVue from './About.vue';
	export default {
		name: 'home',
		data(){
			return {
				ltgzlist: [],
				whncSliderList: [],
        audioPlay: audioPlay,
				bannerHeight:"",
        audioPause: audioPause,
				swiperBtn: true,
				isfalse:true,
				swiperList:[],
				mediaPartnersList:[
					require("../../../static/img/nocolor_1.png"),
					require("../../../static/img/nocolor_2.png"),
					require("../../../static/img/nocolor_3.png"),
					require("../../../static/img/nocolor_4.png"),
					require("../../../static/img/nocolor_5.png"),
					require("../../../static/img/nocolor_6.png"),
					require("../../../static/img/nocolor_7.png"),
					require("../../../static/img/nocolor_8.png"),
					require("../../../static/img/nocolor_9.png"),
					require("../../../static/img/nocolor_20.png"),
				],
				businessPartnersList:[
					require("../../../static/img/nocolor_10.png"),
					require("../../../static/img/nocolor_11.png"),
					require("../../../static/img/nocolor_12.png"),
					require("../../../static/img/nocolor_13.png"),
					require("../../../static/img/nocolor_14.png"),
					require("../../../static/img/nocolor_15.png"),
					require("../../../static/img/nocolor_16.png"),
					require("../../../static/img/nocolor_17.png"),
					require("../../../static/img/nocolor_18.png"),
					require("../../../static/img/nocolor_19.png"),

				],
				mediaPartnersList1:[
					require("../../../static/img/images/logo/media1.png"),
					require("../../../static/img/images/logo/media2.png"),
					require("../../../static/img/images/logo/media3.png"),
					require("../../../static/img/images/logo/media4.png"),
					require("../../../static/img/images/logo/media5.png"),
					require("../../../static/img/images/logo/media6.png"),
					require("../../../static/img/images/logo/media7.png"),
					require("../../../static/img/images/logo/media8.png"),
					require("../../../static/img/images/logo/media9.png"),
					require("../../../static/img/images/logo/media10.png")
				],
				businessPartnersList1:[
					require("../../../static/img/images/logo/enterprise1.png"),
					require("../../../static/img/images/logo/enterprise2.png"),
					require("../../../static/img/images/logo/enterprise3.png"),
					require("../../../static/img/images/logo/enterprise4.png"),
					require("../../../static/img/images/logo/enterprise5.png"),
					require("../../../static/img/images/logo/enterprise6.png"),
					require("../../../static/img/images/logo/enterprise7.png"),
					require("../../../static/img/images/logo/enterprise8.png"),
					require("../../../static/img/images/logo/enterprise9.png"),
					require("../../../static/img/images/logo/enterprise10.png")
				],
				start1:"scale3d(1.15,1.2,1) translate(-45%,-45%)",
				end1:"translate(-50%,-50%)"
			}
		},
		methods:{
			//视频的播放
			playingVideo(){
				var video = document.getElementById('video');
				var videoImg = document.getElementById('videoImg');
				videoImg.style.display = "none";
				video.style.display = "block";
				video.play();
			},
			//音频的播放
			playingAudio(index){ //图片的点击事件
				var myAudio = document.getElementById(index);
				var audioPlayer = document.getElementById("audioPlayer"+index);
				if (myAudio.paused) {
					// 开始播放当前点击的音频
					myAudio.play();
					audioPlayer.src = audioPause
					this.swiperBtn = false
				} else {
					myAudio.pause();
					audioPlayer.src = audioPlay
					this.swiperBtn = true
				}
				myAudio.addEventListener('ended', function () {
        	audioEnded();
				}, false);
				function audioEnded() {
					audioPlayer.src = audioPlay
				}
			},
			// 媒体伙伴鼠标移入
			enter1(index){
				var _this = this;
				var logo1img = document.getElementsByClassName("logo1img")[index];
				logo1img.src = _this.mediaPartnersList1[index];
				logo1img.style.transform = _this.start1;

			},
			// 媒体伙伴鼠标移出
			leave1(index){
				var _this = this;
				var logo1img = document.getElementsByClassName("logo1img")[index];
				logo1img.src = _this.mediaPartnersList[index];
				logo1img.style.transform = _this.end1;
			},
			// 企业品牌鼠标移入
			enter2(index){
				var _this = this;
				var logo1img = document.getElementsByClassName("logo2img")[index];
				logo1img.src = _this.businessPartnersList1[index];
				logo1img.style.transform = _this.start1;

			},
			// 企业品牌鼠标移出
			leave2(index){
				var _this = this;
				var logo1img = document.getElementsByClassName("logo2img")[index];
				logo1img.src = _this.businessPartnersList[index];
				logo1img.style.transform = _this.end1;
			},
			goDetails(id){
      this.$router.push({
        path:"/detail?id="+id
      });
			},
			goAbout(){
				this.$router.push({
					path:"/about",
					name:"about"
				})
				document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
			},
			goDiscover(){
				this.$router.push({
					path:"/discover",
					name:"discover"
				})
				document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
			},
			goLink(val){
				var str = val.str_link_url;
				if(str.indexOf("http")>=0 && val.str_link_url !='' ){
					window.open(val.str_link_url, '_blank').location;
				}else{
					this.$router.push(val.str_link_url);
				}	
			},
			urlStyle(val){
				if(val.str_link_url != ''){
					this.isfalse  = false;
				}else{
					this.isfalse = true;
				}
			
			},
			imgload(){
				this.$nextTick(()=>{
					if(this.$refs.bannerHeight){
						this.bannerHeight = this.$refs.bannerHeight[0].height;
					}
				})
			}
		},
		created(){
			this.$parent.activeIndex = 'home'
			this.axios.post(
				process.env.API_HOST + '/homeprogram'
			)
			.then(res => {
				this.ltgzlist = res.data.msg
			})
			.catch(error => {
				// console.log(error);
				this.$toast("网络错误，不能访问");
			})
			this.axios.post(
				process.env.API_HOST + '/homenews'
			)
			.then(res => {
				this.whncSliderList = res.data.msg
			})
			.catch(error => {
				// console.log(error);
				this.$toast("网络错误，不能访问");
			})
			this.axios.post(
				process.env.API_HOST + '/getBanner'
			)
			.then(res => {
				this.swiperList = res.data.msg	
			})
			.catch(error => {
				// console.log(error);
				this.$toast("网络错误，不能访问");
			})

		},
		mounted(){
			this.imgload();
			window.addEventListener('resize',()=>{
				if(this.$refs.bannerHeight){
						this.bannerHeight = this.$refs.bannerHeight[0].height
					}
				this.imgload();
			},false)
		}
	}
</script>

<style scoped>
.isUrl{
	cursor: pointer;
}
.wnds_home{
	display: inline-table;
	width: 100%;
	background: #fff;
	
}
.newsTitle{
	text-align: center;
}
.newsTitle h2{
	font-size: 24px;
	color: #4c4c4c;
	/* font-weight: 500; */
	letter-spacing: 5px;
	opacity:0.9;
}
.newsTitle h1{
	color: #a3a3a3;
	font-size: 48px;
	letter-spacing: 25px;
	padding-bottom: 50px;
	font-weight: 500;
	margin: -10px 0 0 5px;
	opacity:0.3;
}
	#audio{
		border: #477373;
		position: relative;
		z-index: 99;
	}
	#video{
		display: none;
		outline: none;
	}
	.wh_banner, .wh_banner img{
    	width: 100%;
			height: 100%;
	}
	.wh_aboutusbox {
    width: 100%;
    background-color: #f8f8f8;
    position: relative;
	}
	.wha_lficon{
    width: 37.86%;
    height: 490px;
    background-color: #fff;
    position: absolute;
    top: 190px;
    left: 0;
	}
	.wha_lficon_bgm{
    width: 92.6%;
    margin-left: -46.28%;
    position: absolute;
    top: 250px;
    left: 50%;
	}
	.wh_aboutus{
    width: 1142px;
    margin: 0 auto;
    padding-top: 60px;
    padding-bottom: 190px;
    position: relative;
	}
	.wha_title01{
    display: block;
    margin: 0 auto;
    margin-bottom: 140px;
	}
	.whac_logo {
    width: 536px;
    height: 350px;
    font-size: 0;
    position: relative;
    box-shadow: 0 0 40px -9px #477373;
	}
	.whac_logo img {
			width: 100%;
			height: 100%;
	}
	.whac_logo .what_btn {
			cursor: pointer;
			width: 49px;
			height: 49px;
			margin-left: -24.5px;
			margin-top: -24.5px;
			position: absolute;
			top: 50%;
			left: 50%;
		
	}

	.whac_text {
			width: 538px;
			padding-top: 65px;
			font-weight: 400;
			color: #828282;
	}
	.whac_text p:first-child {
			font-size: 24px;
			line-height: 24px;
			color: #658e31;
	}
	.whac_text p:nth-child(2) {
			margin-top: 12px;
			margin-bottom: 28px;
			font-size: 12px;
			line-height: 12px;
			font-family: myfont;
	}
	.whac_text p:nth-child(3) {
			font-size: 14px;
			line-height: 26px;
			text-align: justify;
			font-family: myfont;
	}
	.whac_getmore {
    cursor: pointer;
    float: right;
    margin-top: 40px;
	}
	.wh_ltgzbox {
    width: 100%;
}
.wh_ltgz {
    width: 1142px;
    margin: 0 auto;
    padding-top: 60px;
    padding-bottom: 200px;
    text-align: right;
    position: relative;
}
.whl_title02 {
    margin-bottom: 70px;
}
.swiper-container {
    overflow: unset;
}
.whl_content02 {
    position: relative;
    background-color: #fff;
}
.whlc_text {
    width: 339px;
    margin-right: 140px;
		margin-top: 20px;
    text-align: left;
    font-family: myfont;
}
.whlc_text>p {
    width: 339px;
}
.whlc_text>p:first-child {
    margin-bottom: 20px;
    font-size: 22px;
    line-height: 22px;
    color: #484848;
}
.whlc_text>p:nth-child(2) {
    margin-bottom: 34px;
    font-size: 12px;
    line-height: 20px;
    color: #838383;
}
.whlc_txtdet, .whlc_txtdet_box {
    height: 300px;
    text-align: justify;
    font-size: 14px;
    line-height: 24px;
    color: #a0a0a0;
}

.whlc_txtdet_box {
    overflow: hidden;
    width: 339px;
}
.whlc_txtdet {
    overflow-y: scroll;
    width: 356px;
		/* float: left; */
}
.whlc_logo {
    width: 450px;
    height: 330px;
    margin-top: -370px;
		margin-left: 460px;
		/* float: left; */
    font-size: 0;
    position: relative;
}
.whlc_logo_bgm {
    position: relative;
    z-index: 100;
}	
.whlc_logo img {
    width: 100%;
    height: 100%;
}
.whlc_logo .whlc_btn {
    cursor: pointer;
    width: 56px;
    height: 57px;
    margin-top: -28px;
    margin-left: -28.5px;
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 111;
}
.whlc_logo .whlc_logo_shawn, .whlc_logo .whlc_logo_shawn_top {
    width: 450px;
    height: 330px;
    position: absolute;
    top: 60px;
    left: 230px;
    z-index: 1;
}
.whlc_logo .whlc_logo_shawn_top {
    background-color: #fff;
    z-index: 10;
    opacity: .7;
}

.whlc_logo .whlc_logo_shawn, .whlc_logo .whlc_logo_shawn_top {
    width: 450px;
    height: 330px;
    position: absolute;
    top: 60px;
    left: 230px;
    z-index: 1;
}
.whlc_bg_icon {
    width: 212px;
    height: 106px;
    position: absolute;
    top: 100px;
    right: 5px;
    z-index: 999;
}
.wh_ltgz .swiper-pagination-bullet-active {
    background: #bfc32d;
}
.swiper-pagination-custom, .swiper-pagination-fraction, .wh_ltgz .swiper-container-horizontal>.swiper-pagination-bullets {
    width: 200px;
    bottom: -10px;
    right: 0;
    left: unset;
}
.swiper-container-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet {
    margin: 0 4px;
}
.whac_getmore_ltgz {
    cursor: pointer;
    display: block;
    width: 106px;
    height: 36px;
    margin-left: -53px;
    position: absolute;
    bottom: 80px;
    left: 50%;
		/* margin-top: 50px; */
}
.wh_newsbox {
    width: 100%;
    background-color: #f8f8f8;
}
.wh_news {
    width: 1142px;
    margin: 0 auto;
    padding-top: 60px;
    padding-bottom: 120px;
    position: relative;
}
.whn_title03 {
    display: block;
    margin: 0 auto;
		margin-bottom: 90px;
}
.whnc_list {
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
}
.whnc_slider {
    overflow: hidden;
    width: 366px;
    font-family: myfont;
    padding-bottom: 28px;
    margin-bottom: 50px;
    background-color: #fff;
}
.whnc_slider_empt {
    height: 0;
    margin: 0;
    padding: 0;
}
.whnc_slider>img:first-child {
    width: 100%;
    height: 266px;
}
.whnc_slider p {
    margin: 0 18px;
}
.whnc_slider p {
    margin: 0 18px;
}
.whnc_slider .strNewsTitle {
    overflow: hidden;
    text-overflow: ellipsis;
    margin-top: 20px;
    font-size: 22px;
    line-height: 30px;
    color: #565656;
    position: relative;
}
.whnc_slider .strKey {
    overflow: hidden;
    text-overflow: ellipsis;
    margin-top: 14px;
    margin-bottom: 22px;
    font-size: 14px;
    line-height: 20px;
    color: #6d6d6d;
    position: relative;
}
.whnc_slider .strKey.p_after_strKey:after, .whnc_slider .strNewsTitle.p_after:after {
    content: "...";
    position: absolute;
    bottom: 0;
    right: 0;
    padding-left: 40px;
    background: linear-gradient(90deg,hsla(0,0%,100%,0),#fff 55%);
}
.whnc_slider:hover {
    cursor: pointer;
    transform: scale(1.02);
    -ms-transform: scale(1.02);
    -moz-transform: scale(1.02);
    -webkit-transform: scale(1.02);
    -o-transform: scale(1.02);
    box-shadow: 0 0 40px -6px #dfdfdf;
}
.wh_partnerbox {
    width: 100%;
    background-color: #f8f8f8;
		/* margin-top: -125px; */
}
.wh_partner {
    width: 1200px;
    margin: 0 auto;
    padding-top: 90px;
    padding-bottom: 130px;
}
.whp_title04 {
    display: block;
    margin: 0 auto;
}
.wh_partner_pic {
    display: block;
    margin: 0 auto;
    margin-top: 90px;
}

.wh_partner h2{
	text-align: center;
	line-height: 60px;
	color: #5f5f5f;
}
.mediaPartners_box{
	margin-top: 30px;
}
.logo_box{
	margin-top: 20px;
	display: flex;
  justify-content: space-between;
  flex-wrap:wrap;
}
.logo1:hover{
	-webkit-box-shadow: 0px 0px 30px -10px #cccccc;
  box-shadow: 0px 0px 30px -10px #cccccc;
}
.logo1{
	width: 230px;
	height: 88px;
	background: #fff;
	margin-bottom: 35px;
	position: relative;
}
.logo1 img{
	display: inline-block;
	position: absolute;
  top: 50%;
  left: 50%;
	transform: translate(-50%,-50%);
}
.logo2{
	width: 230px;
	height: 88px;
	background: #fff;
	margin-bottom: 35px;
	position: relative;
}
.logo2 img{
	display: inline-block;
	position: absolute;
  top: 50%;
  left: 50%;
	transform: translate(-50%,-50%);
}
.logo2:hover{
	-webkit-box-shadow: 0px 0px 30px -10px #cccccc;
  box-shadow: 0px 0px 30px -10px #cccccc;
}
</style>





// WEBPACK FOOTER //
// src/components/page/Home.vue